<button class="close float-right" matDialogClose>&times;</button>
<h2 mat-dialog-title>Confirmar Exclusão</h2>
<mat-dialog-content class="mat-typography">
    <div mat-dialog-content class="mat-typography" style="max-height: 100%;">
        <div class="row">
            <p style="padding-left: 20px">Deseja confirmar a exclusão do registro?</p>
        </div>
        <div class="card-footer pr-0">
            <div class="d-flex flex-row justify-content-end">
                <div class="pr-3">
                    <button mat-raised-button label="Não" matDialogClose title="Não" aria-label="left">Não</button>
                </div>
                <div>
                    <button mat-raised-button color="primary" label="Sim" matDialogClose (click)="excluir()" title="Sim" aria-label="left">Sim</button>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
